export const CATCH_UP_FRIDAYS_DESCRIPTION =
  'Unlock the potential of Catch-Up Fridays to enrich your afternoons with meaningful activities. By integrating concepts from Values, Health, and Peace Education, students can strengthen their foundational and social skills.';
export const CATCH_UP_FRIDAYS_PAGE_TITLE = 'Catch-Up Fridays';

export const CATCH_UP_FRIDAYS_HEADINGS = [
  'I. General Overview:',
  'II. Session Outline:',
  'III. Teaching Strategies:',
]

export const CATCH_UP_FRIDAYS_SECTIONS = [
  'Subject Integration:',
  'Introduction and Warm Up:',
  'Concept Exploration:',
  'Valuing:',
  'Reflection:',
]
